/**
 * AiSummaryPreview — read-only paper preview of the AI treatments summary PDF.
 * Same block structure / class names as functions/treatmentsSummaryHtmlTemplate.js:
 * letterhead → addressee → title → patient meta → sessions chips → summary body
 * → signature → footnote. Shared blocks from components/pdfExport/PdfPaperBlocks.js.
 */

import {
  Paper,
  PaperLetterhead,
  PaperAddressee,
  PaperTitle,
  PaperPatientMeta,
  PaperChips,
  PaperEmpty,
  PaperSignature,
  PaperFootnote,
  PaperFooterStrip,
} from "../../pdfExport/PdfPaperBlocks";

function AiSummaryPreview({ model }) {
  return (
    <Paper>
      <PaperLetterhead letterhead={model.letterhead} />
      <PaperAddressee text={model.addressee} />
      <PaperTitle text={model.title} />
      <PaperPatientMeta rows={model.patientRows} />
      {model.sessionChips.length > 0 && (
        <div className="doc-chips sessions-list">
          <span className="doc-chips-label">פגישות שנכללו:</span>
          {model.sessionChips.map((c, i) => (
            <span key={i} className="doc-chip">
              {c.text}
            </span>
          ))}
        </div>
      )}
      <PaperChips chips={[]} />

      <main className="ck-form-doc">
        {model.bodyHtml ? (
          <div className="summary-body" dangerouslySetInnerHTML={{ __html: model.bodyHtml }} />
        ) : (
          <PaperEmpty>עדיין אין סיכום — צרו סיכום עם AI או כתבו טקסט בעורך.</PaperEmpty>
        )}
        <PaperSignature signature={model.signature} />
      </main>

      <PaperFootnote text={model.footerNote} />
      <PaperFooterStrip />
    </Paper>
  );
}

export default AiSummaryPreview;
